var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Chip as MuiChip } from "@mui/material";
import { chipSxProps } from "../AutocompleteTagging.styles";
import { COLORS } from "../../../../../constants";
import Text from "../../../Text";
var AutocompleteChip = function (_a) {
    var option = _a.option, deleteIcon = _a.deleteIcon, _b = _a.style, style = _b === void 0 ? {} : _b, isOption = _a.isOption, _c = _a.sx, sx = _c === void 0 ? {} : _c, rest = __rest(_a, ["option", "deleteIcon", "style", "isOption", "sx"]);
    var renderChip = function () { return (_jsx(MuiChip, __assign({ style: __assign({}, style), sx: __assign(__assign(__assign({}, chipSxProps), { background: COLORS[(option === null || option === void 0 ? void 0 : option.color) || "LIGHT_GREEN"], overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", ".MuiChip-label": {
                overflow: "hidden",
                lineHeight: "normal",
            } }), sx), "data-testid": "chip-".concat(option.id, "-").concat(isOption ? "y" : "n"), size: "small", label: option.name, deleteIcon: deleteIcon }, rest))); };
    if (option.new && isOption) {
        return (_jsxs(Box, { children: [_jsx(Text, __assign({ variant: "body3", component: "span" }, { children: "Create" })), " ", renderChip()] }));
    }
    return renderChip();
};
export default React.memo(AutocompleteChip);
